import * as React from 'react';
import {defineMessage} from 'react-intl';
import {BuildInstructions} from '../../components/left-col';

export const buildInstructions = [
  {
    label: 'Go',
    body: {
      message: defineMessage({
        id: 'docsApp.ib.aap.snippets.go.go.body',
        defaultMessage: 'Make sure to initialize with Go Modules:',
      }),
    },
    command: 'go get -u github.com/stripe/stripe-go',
    shell: true,
  },
  {
    label: 'GitHub',
    body: {
      message: defineMessage({
        id: 'docsApp.ib.aap.snippets.go.github.body',
        defaultMessage:
          'Or download the stripe-go module source code directly ',
        description:
          'First part of a sentence that ends in docsApp.ib.aap.snippets.go.github.link . Please translate them with this in mind.',
      }),
    },
    link: {
      href: 'https://github.com/stripe/stripe-go',
      label: {
        message: defineMessage({
          id: 'docsApp.ib.aap.snippets.go.github.link',
          defaultMessage: 'from GitHub.',
          description:
            'Second part of a sentence that begins in with docsApp.ib.aap.snippets.go.github.body . Please translate them with this in mind.',
        }),
      },
    },
  },
];

export const setup = {
  heading: {
    message: defineMessage({
      id: 'docsApp.ib.aap.snippets.go.setup.heading',
      defaultMessage: 'Set up your server',
    }),
  },
  body: {
    message: defineMessage({
      id: 'docsApp.ib.aap.snippets.go.setup.body',
      defaultMessage:
        'Add the dependency to your build and import the library. Alternatively, if you’re starting from scratch and need a go.mod file, download the project files using the link in the code editor.',
    }),
  },
  Component() {
    return <BuildInstructions instructions={buildInstructions} />;
  },
};

export const run = `go run server.go`;
